import { createContext } from 'react';
/**
 * Context for FeaturePanel.
 */
export const featurePanelContext = createContext({
    isFeaturePanelOpen: false,
    setIsFeaturePanelOpen: () => { },
});
